<script lang="ts">
    import type Monster from "../../lib/monster";
    import { getPathFor } from "../Attributes/util";
    import type { Point } from "../Attributes/util";
    import { convertNormalizedPath, generateFillColor } from "./util";
    export let monster: Monster;
    export let dimensions: number;
    const normalizedRange = 10;

    const generatePath = (sideLength: number): Point[] => {
        const path: Point[] = convertNormalizedPath(
            [
                { x: 1, y: 3 },
                { x: 1, y: 8 },
                { x: 0, y: 9.5 },
                { x: 1.5, y: 9.5 },
                { x: 2.5, y: 8 },
                { x: 2.5, y: 5.5 },
                { x: 7, y: 5.5 },
                { x: 7, y: 8 },
                { x: 8, y: 9.5 },
                { x: 9.5, y: 9.5 },
                { x: 8.5, y: 8 },
                { x: 8.5, y: 3 },
            ],
            sideLength * 1.3,
            4,
            1.55
        );

        return path;
    };
</script>

{#if dimensions}
    <path
        d={getPathFor(generatePath(dimensions))(
            { x: dimensions / 2, y: dimensions / 2 },
            normalizedRange
        )}
        stroke="black"
        fill={generateFillColor('speed', monster)}
    />
{/if}

<style>
</style>
